import { formatHtml } from "@trumpf/ux.common-storybook";
import { JobOffersTemplate } from "./job-offers.templates";

export default {
    title: "Website/Partial Templates/Job Offers",
    render: JobOffersTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
